"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisplayOptions = void 0;
var React = __importStar(require("react"));
var Select_1 = __importDefault(require("../../Select/Select"));
var localization_1 = require("@scuf/localization");
var DisplayOptions = /** @class */ (function (_super) {
    __extends(DisplayOptions, _super);
    function DisplayOptions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DisplayOptions.prototype.render = function () {
        var _a = this.props, itemsPerPageOptions = _a.itemsPerPageOptions, itemsPerPageAllEnabled = _a.itemsPerPageAllEnabled, onPageChangeHandle = _a.onPageChangeHandle, defaultOption = _a.defaultOption, totalItems = _a.totalItems, t = _a.t;
        var options = [];
        itemsPerPageOptions.forEach(function (pages) {
            options.push({ text: pages.toString(), value: pages });
        });
        if (itemsPerPageAllEnabled) {
            options.push({ text: t('View All'), value: totalItems });
        }
        return (React.createElement("div", { className: "page-options" },
            t('Items per Page'),
            React.createElement(Select_1.default, { placeholder: "", options: options, onChange: function (value) { return onPageChangeHandle(value); }, defaultValue: defaultOption })));
    };
    return DisplayOptions;
}(React.Component));
exports.DisplayOptions = DisplayOptions;
exports.default = localization_1.InjectLocalization(DisplayOptions);
